module.exports = __webpack_public_path__ + "img/9.d968c78.png";